<template>
  <v-dialog
    v-model="show"
    scrollable
    :max-width="maxWidth"
    persistent
    :fullscreen="fullscreen"
  >
    <v-card>
      <v-card-title class="grey lighten-3">
        <v-row align="center">
          <v-icon v-if="draggable" class="draggable">mdi-drag</v-icon>
          <v-col class="py-0" cols="10">
            <slot name="title"></slot>
          </v-col>
          <v-col class="py-0">
            <v-container py-0
              ><v-row justify="end">
                <v-btn icon color="indigo" @click="$emit('close')">
                  <v-icon>mdi-close</v-icon>
                </v-btn></v-row
              ></v-container
            >
          </v-col>
        </v-row>
      </v-card-title>
      <slot name="top"></slot>
      <v-card-text class="pa-3 pt-1">
        <slot></slot>
      </v-card-text>
      <v-card-actions class="grey lighten-4">
        <v-spacer></v-spacer>
        <slot name="actions-left"></slot>
        <v-btn
          color="warning"
          text
          @click="$emit('close')"
          :disabled="closeDisabled"
          >Close</v-btn
        >
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "basic-dialog",
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    maxWidth: {
      type: String,
      default: () => "1200px",
    },
    draggable: {
      type: Boolean,
      default: () => true,
    },
    fullscreen: {
      type: Boolean,
      default: () => false,
    },
    closeDisabled: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/BasicDialog.vue